import { useParams } from "react-router-dom";

import { Area, Post } from "@/api/areas/types";
import { AreaContext } from "@/hooks/useAreaContext";
import { PostDetailContext } from "@/hooks/usePostDetailContext";
import { PostDetailsLayout } from "@/routes/clients/PostDetails";

import { useClientContext } from "./client-data-loader";

export function PostDetailDataLoader() {
  const { areaId, postAddress } = useParams();
  const client = useClientContext();

  if (!areaId || !postAddress) {
    throw new Response("Area ID and Post Address are required", {
      status: 404,
    });
  }

  const area = client.areas?.find((area) => area._id === areaId) as Area;
  const post = area?.posts?.find(
    (post) => post.address === Number(postAddress)
  ) as Post;

  if (!post) {
    throw new Response("PostDetail not found", { status: 404 });
  }

  return (
    <AreaContext.Provider value={{ area }}>
      <PostDetailContext.Provider
        value={{ post: { ...post, belongsToClient: true } }}
      >
        <PostDetailsLayout />
      </PostDetailContext.Provider>
    </AreaContext.Provider>
  );
}
